import React from 'react';

const Blue = () => {
  return <div>Blue</div>;
};

export default Blue;
